import { InfoCircleFilled } from '@ant-design/icons';
import { message } from 'antd';

const errorMessage = (text?: string) => {
  return message.error({
    icon: <InfoCircleFilled style={{ top: '-3px' }}></InfoCircleFilled>,
    content: text || 'Ocurrio un error intente mas tarde',
    style: { marginTop: '50px' }
  });
};
export default errorMessage;
